import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCart = () => {
  return (
    <g>
      <path d="m15.746 3.2629a.75.75 0 0 0 -.5781-.272h-10.6861l-.1113-1.8886a.75.75 0 0 0 -.7485-.7061h-2.7901a.75.75 0 1 0 0 1.5h2.083l.4439 7.5259a.75.75 0 0 0 .7485.706h9.9827a.7506.7506 0 0 0 .7368-.6094l1.0776-5.6372a.75.75 0 0 0 -.1584-.6186zm-2.276 5.3653h-8.6556l-.2437-4.1372h9.69z" />
      <path d="m5.5448 11.3289a2.1375 2.1375 0 1 0 2.1372 2.1372 2.14 2.14 0 0 0 -2.1372-2.1372zm0 2.8745a.7371.7371 0 1 1 .7368-.7373.7379.7379 0 0 1 -.7368.7373z" />
      <path d="m12.1576 11.3289a2.1375 2.1375 0 1 0 2.1377 2.1372 2.14 2.14 0 0 0 -2.1377-2.1372zm0 2.8745a.7371.7371 0 1 1 .7373-.7373.7378.7378 0 0 1 -.7373.7373z" />
    </g>
  );
};

export default withIcon(IconCart);
